import {
  FETCH_RECENT_EVENTS,
  FETCH_RECENT_EVENTS_FAILURE,
  FETCH_RECENT_EVENTS_SUCCESS,
} from '../actions/RecentEventsActions';

const initialState = {
  loading: false,
  error: null,
  data: [],
};

const recentEventsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_RECENT_EVENTS:
      return {
        ...state,
        loading: true,
      };
    case FETCH_RECENT_EVENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.data,
      };
    case FETCH_RECENT_EVENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default recentEventsReducer;
